export default "__VITE_ASSET__CmM8vlMw__"